import { render } from "./App.vue?vue&type=template&id=4b9791e0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4b9791e0&lang=css"

import exportComponent from "D:\\rwkj\\suershouyyph-mobile\\保安端\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__